// LeadUserDefineFieldsSection.js
import React from 'react';

const LeadUserDefineFieldsSection = ({ KeyNameList, formData, errors, handleInputChange, handleDecimalChange, handleIntegerChange, handleFileChange }) => {

    const renderField = (keyItem) => {
        const { TypeName, vc_Name, vc_Description } = keyItem;

        const commonProps = {
            name: vc_Name,
            className: "form-control",
            value: formData[vc_Name] || '',
            placeholder: vc_Description || '',
            onChange: (e) => handleInputChange(e, keyItem),
        };

        switch (TypeName) {
            case "Text": return <input type="text" {...commonProps} />;
            case "Textarea": return <textarea rows={2} {...commonProps} />;
            case "Select":
                return (
                    <select {...commonProps}>
                        <option value="0">Select an Option</option>
                        {keyItem.options && keyItem.options.map(option => (
                            <option key={option.ID} value={option.ID}>{option.Name}</option>
                        ))}
                    </select>
                );
            case "Integer": return <input type="text" {...commonProps} onChange={handleIntegerChange} />;
            case "Decimal":
            case "Currency": return <input type="text" {...commonProps} onChange={handleDecimalChange} />;
            case "DateTime": return <input type="datetime-local" {...commonProps} />;
            case "Formula": return <input type="text" {...commonProps} />;
            case "Image":
            case "File":
                return <input type="file" className="form-control file-control col-sm-8" name={vc_Name} onChange={handleFileChange} />;
            case "Yes/No":
                return (
                    <select {...commonProps}>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                );
            default: return null;
        }
    };

    const renderFormFields = () => {
        const rows = [];
        for (let i = 0; i < KeyNameList.length; i += 2) {
            const field1 = KeyNameList[i];
            const field2 = KeyNameList[i + 1];

            rows.push(
    <tr key={i}>
        <td className="fw-bold align-middle" >
            <label htmlFor="FK_LeadOpportunitySource_Id" style={{ float: "right" }}> {field1.vc_Name} &nbsp;&nbsp;</label>

        </td>

        <td>
            {renderField(field1)}
            {errors[field1.vc_Name] && (
                <div style={{ color: 'red', fontSize: '0.8vw' }}>
                    {errors[field1.vc_Name]} 
                </div>
            )}
        </td>

        {field2 ? (
            <>
                <td className="fw-bold align-middle">
                   <label htmlFor="FK_LeadOpportunitySource_Id" style={{ float: "right" }}>  {field2.vc_Name} &nbsp;&nbsp;</label>
                </td>

                <td>
                    {renderField(field2)}
                    {errors[field2.vc_Name] && (
                        <div style={{ color: 'red', fontSize: '0.8vw' }}>
                            {errors[field2.vc_Name]}
                        </div>
                    )}
                </td>
            </>
        ) : (
            <>
               
            </>
        )}
    </tr>
);

        }
        return rows;
    };

    return <>{renderFormFields()}</>;
};

export default LeadUserDefineFieldsSection;
